import React, { Fragment } from "react";
import { GoogleTracking } from "../../google/GoogleTracking";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";

const HeaderCtas = (props) => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <div className={"my-3 ctas btn-group" + (props.btnGroupClass ? (' ' + props.btnGroupClass) : '')}>
        {props.headerCtas
          ? props.headerCtas.map((header) => {
              return (
                <button
                  key={header.id}
                  type="button"
                  onClick={() => {
                    if (header.ga_actions_id) {
                      GoogleTracking({
                        ga_data: {
                          type: "event",
                          data: {
                            category: header.ga_category,
                            action: header.ga_action,
                            label: header.ga_label,
                          },
                        },
                      });
                    }

                    if (header.url_type.toLowerCase() === "external") {
                      window.open(header.url);
                    } else {
                      props.history.push(header.url);
                    }
                  }}
                  className={
                    (header.style.toLowerCase() === "dark"
                      ? "btn-primary"
                      : "btn-light") + " btn btn-xl"
                  }
                >
                  <span>{t(header.label)}</span>
                </button>
              );
            })
          : null}
      </div>
    </Fragment>
  );
};

export default withRouter(HeaderCtas);
